<template>
    <div>
        <ForeignEmployeesTable/>
    </div>
</template>

<script setup>
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ForeignEmployeesTable from "@/components/dashboard/foreign-employees/ForeignEmployeesTable.vue";

</script>
